import _ from 'underscore';
import { isCopilotRegionRestricted } from '@bingads-webui-react/copilot-utils';

export function getIsCopilotSummaryButtonEnabled({
  permissions,
  search = undefined,
  serverContext,
}) {
  const isAdsCopilotReportingInsightsEnabled = _.get(permissions, ['dynamic', 'AdsCopilotReportingInsights'], false);
  if (isAdsCopilotReportingInsightsEnabled) {
    // check if Copilot Chat is restricted based on the user's region
    return isCopilotRegionRestricted({
      feature: 'Chat',
      permissions,
      search,
      serverContext,
    }).then(isRestricted => !isRestricted);
  }
  return Promise.resolve(false);
}
